export const catalog_matrix = [
  {form_key:'consulting_status_id', catalog_key:'consulting_statuses'},
  {form_key:'consulting_progress_id', catalog_key:'consulting_progresses'},
  {form_key:'mod_type_id', catalog_key:'mod_types'},
]